import React from 'react'
import PropTypes from 'prop-types'

// @mui components
import { Dialog, DialogTitle, DialogContent, Grid } from '@mui/material'

// formik components
import { Formik, Form } from 'formik'
import Textfield from 'components/FormsUI/Textfield'
import * as Yup from 'yup'

// Material Dashboard Pro 2 components
import MDButton from 'components/MDButton'
import Select_Rd from 'components/FormsUI/Select/Select_Rd'


export default function EditAreaDialog(props){
  console.log('props', props)
  const managerList = props.areaMgrs
  const typeList = { Company: 'Company', Franchise: 'Franchise', 'Ghost Kitchen': 'Ghost Kitchen'}

  function handleSubmit(values){
    props.submit({
      index: props.data.index,
      oldData: props.data.original,
      newData: values
    })
  }

  const INITIAL_FORM_STATE = {
    areaName: props.data.values.areaName,
    areaManager: props.data.values.areaManager,
    areaType: props.data.values.areaType
  }

  const FORM_VALIDATION = Yup.object().shape({
    areaName: Yup.string(),
    areaManager: Yup.string(),
    areaType: Yup.string()
  })

  return (
    <Dialog
      open={ props.open }
    >
      <DialogTitle>{props.data.values.area}</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={INITIAL_FORM_STATE}
          validationSchema={FORM_VALIDATION}
          onSubmit={ (values) => { handleSubmit(values) }}
        >
          {({ isValid, dirty }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12} 
                  // Included to give spacing to 'role' Texfield
                />
                <Grid item xs={12}>
                  <Textfield 
                    name='areaName'
                    label='Area Name'
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select_Rd 
                    name='areaManager'
                    options={ managerList }
                    label='Area Manager'
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select_Rd 
                    name='areaType'
                    options={ typeList }
                    label='Area Type'
                  />
                </Grid>
                
                <Grid item xs={6} />
                <Grid item xs={3}>
                  <MDButton variant='contained' color='info' onClick={ props.close }>
                    Cancel
                  </MDButton>
                </Grid>
                <Grid item xs={3}>
                  <MDButton variant='contained' color='info' type='submit' disabled={!(dirty && isValid)}>
                    Submit
                  </MDButton>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

EditAreaDialog.propTypes = {
  close: PropTypes.func,
  data: PropTypes.object,
  areaMgrs: PropTypes.object,
  open: PropTypes.bool,
  submit: PropTypes.func,
}